import axios from '@/libs/api.request'

// 获取区域列表
export const getAreaList = (data) => {
  return axios.request({
    url: 'area/page',
    data: data,
    method: 'post',
  })
}
// 添加区域
export const addArea = (data) => {
  return axios.request({
    url: 'area/add',
    data: data,
    method: 'post',
  })
}
// 编辑区域
export const editArea = (data) => {
  return axios.request({
    url: 'area/update',
    data: data,
    method: 'post',
  })
}
// 删除区域
export const deleteArea = (data) => {
  return axios.request({
    url: 'area/del',
    data: data,
    method: 'post',
  })
}
// 根据角色获取区域列表
export const getAreaListByRole = (data) => {
  return axios.request({
    url: 'area/list',
    data: data,
    method: 'post',
  })
}
// 获取区域详情（含边界、车道等）
export const getAreaDetail = (data) => {
  return axios.request({
    url: 'area/detail',
    data: data,
    method: 'post',
  })
}

// 获取所有区域边界
export const getAreaBoundaries = (data) => {
  return axios.request({
    url: 'area/boundary',
    data: data || {},
    method: 'post',
  })
}
// 检查车辆是否在区域内
export const checkVehicleInArea = (data) => {
  return axios.request({
    url: 'area/check-vehicle',
    data: data,
    method: 'post',
  })
}

/** 导入/覆盖区域可行驶车道 CSV（poly_id,pt_idx,lat_gcj02,lon_gcj02） */
export const importAreaDrivableCsv = (data) => {
  return axios.request({
    url: 'area/drivable-import',
    data,
    method: 'post',
  })
}

/** 清除区域可行驶车道 */
export const clearAreaDrivable = (data) => {
  return axios.request({
    url: 'area/drivable-clear',
    data,
    method: 'post',
  })
}
